var contentFeedService = require('contentFeedService');
var loader = require('loader');
var flickity = require('flickity');
import readableContentType from '../plugins/readable-content-type';


var contentFilter = (function() {

    var $filterForm = $('#content-filter');
    var $filterSubmit = $filterForm.find('button[type="submit"]');
    var $clonedContent = $('#clone-content-teaser');
    var $filterResults = $('#content-filter-results-list');
    var $filterTextContainer = $('.your-filters');
    var $loadMoreBtn = $('#content-filter-load-more');
    var $submitColumn = $filterForm.find('.submit-column');
    var $carousel = $('.content-filter-results .flickity-carousel-outer');
    var $tgFilter = $('.tg-filter');
    var ages = [];
    var contentTypes = [];
    var cursor = '';
    var pageSize;
    var includeLocked;
    var saveParams;
    var moreResults;
    var filterDisabledText;
    var filterEnabledText = 'Find content for me';
    var activeClass = 'active';
    var morePosts;
    var apiResult = false;


    // Configure settings based on if on TG or listing page
    if ($tgFilter.length) {
        pageSize = 8;
        includeLocked = false;
        saveParams = true;
    } else {
        pageSize = 16;
        includeLocked = true;
        saveParams = false;
    }


    var resetResults = function() {
        // If Flickity Exists
        if ($('.content-filter-results .flickity-slider').length) {
            $carousel.flickity('destroy');
        }

        $filterResults.html('');
        $filterTextContainer.html('');
        ages = [];
        contentTypes = [];
        cursor = '';

        hideLoadMore();
    };


    var enableFilterBtn = function() {
        $filterSubmit.html(filterEnabledText);
        $filterSubmit.attr('disabled', false);
    };


    var disableFilterBtn = function() {
        $filterSubmit.html(filterDisabledText);
        $filterSubmit.attr('disabled', true);
    };


    var checkIfFilterSelected = function() {
        if ($filterForm.find(':checked').length) {
            enableFilterBtn();
        } else {
            disableFilterBtn();
        }
    };


    var filterChange = function() {
        filterDisabledText = $filterSubmit.html();

        $filterForm.find('input').on('change', function() {
            hideNoResultsMessage();
            checkIfFilterSelected();
        });
    };


    var filterClick = function() {
        $filterSubmit.on('click', function(e) {
            e.preventDefault();
            resetResults();
            $('window').btnLoader($(this));

            $('input[name="age-group"]:checked').each(function() {
                var age = $(this).val();
                ages.push(age);
            });

            $('input[name="content-type"]:checked').each(function() {
                var contentType = $(this).val();
                contentTypes.push(contentType);
            });

            filterContentService(includeLocked, saveParams, ages, contentTypes, cursor, pageSize, newFilterResponse);
        });
    };


    var newFilterResponse = function(res) {
        if (res.statusCode === 200) {
            cursor = res.data.cursor;
            morePosts = res.data.more;
            var results = res.data.data;

            // If there are results, grab them
            if (results.length) {
                loopThroughResults(results);
                if ($tgFilter.length) {
                    changeFilterText();
                    showResults();
                    buildCarousel();
                }
            } else {
                showNoResultsMessage();
            }

            hideLazyLoadFilters();
            $('window').hideBtnLoader($filterSubmit);
            checkIfMorePosts();
            apiResult = true;
        }
    };


    var loadMoreResponse = function(res) {
        if (res.statusCode === 200) {
            cursor = res.data.cursor;
            morePosts = res.data.more;
            var results = res.data.data;

            // If there are results, grab them
            if (results.length) {
                loopThroughResults(results);
            }

            checkIfMorePosts();
            apiResult = true;
        }
    };


    var loopThroughResults = function(results) {
        for (var i = 0; i < results.length; i++) {
            var result = results[i];

            addContent(result);
        }
    };


    var checkIfMorePosts = function() {
        if (morePosts === true) {
            showLoadMore();
        } else {
            hideLoadMore();
        }
    };


    var changeFilterText = function() {
        const $filterText = $('.content-filter-results .filter-text');

        if (ages.length) {
            var ageFilterText = '';
            var ageFilterName = 'Age group:';

            for (var i = 0; i < ages.length; i++) {
                ageFilterText += ' ' + ages[i].toString();

                if (i != ages.length - 1) {
                   ageFilterText += ',';
                }
            }

            const $ageFilterText = $filterText.clone().removeAttr('hidden').appendTo($filterTextContainer);
            $ageFilterText.find('.filter-value').html(ageFilterText);
            $ageFilterText.find('.filter-name').html(ageFilterName);
        }

        if (contentTypes.length) {
            var contentTypeFilterText = '';
            var contentTypeFilterName = 'Content type:';

            for (var i = 0; i < contentTypes.length; i++) {
                // Horrible hack until we address drills data structure
                if (contentTypes[i] === 'coaching sessions') {
                    contentTypeFilterText += ' practices';
                } else if (contentTypes[i] === '') {
                    contentTypeFilterText += ' everything';
                } else {
                    contentTypeFilterText += ' ' + contentTypes[i];
                }

                if (i != contentTypes.length - 1) {
                   contentTypeFilterText += ',';
                }
            }

            const $contentTypeFilterText = $filterText.clone().removeAttr('hidden').appendTo($filterTextContainer);
            $contentTypeFilterText.find('.filter-value').html(contentTypeFilterText);
            $contentTypeFilterText.find('.filter-name').html(contentTypeFilterName);
        }
    };


    var showResults = function() {
        $tgFilter.find('.content-filter-options').attr('hidden', true);
        $tgFilter.find('.content-filter-results').attr('hidden', false);
    };


    var showFilters = function() {
        $tgFilter.find('.content-filter-options').attr('hidden', false);
        $tgFilter.find('.content-filter-results').attr('hidden', true);
    };


    var showNoResultsMessage = function() {
        $submitColumn.find('.default-text').removeClass(activeClass);
        $submitColumn.find('.no-results-text').addClass(activeClass);
    };


    var hideNoResultsMessage = function() {
        $submitColumn.find('.no-results-text').removeClass(activeClass);
        $submitColumn.find('.default-text').addClass(activeClass);
    };


    var addContent = function(result) {
        var $filteredContent = $clonedContent.clone();
        var $link = $filteredContent.find('a');
        var $date = $filteredContent.find('.teaser-date');
        var $type = $filteredContent.find('.teaser-type');
        var $title = $filteredContent.find('.teaser-title');
        var $subtitle = $filteredContent.find('.teaser-summary');
        var $image = $filteredContent.find('.teaser-thumbnail');
        var $readTime = $filteredContent.find('.teaser-read-time');
        var $newFlag = $('<div class="teaser-new-flag">New</div>');
        var $lockedIcon = $filteredContent.find('.teaser-lock');

        // Consistent values used across all content types
        $filteredContent.removeAttr('id');
        $filteredContent.removeAttr('hidden');
        $link.attr('href', result.slug);

        $date.html(result.date_readable);
        $type.addClass(result.type).find('span').html(readableContentType(result.type));

        $title.html(result.title);
        $subtitle.html(result.plaintext_summary);
        $image.css('background-image', 'url(' + result.thumbnail_image_url + ')');

        // Values that change depending on different states
        if (result.is_new === true) {
            $newFlag.insertAfter($image);
        }

        if (result.unlocked === false) {
            $filteredContent.find('.content-teaser').addClass('content-locked');
        }

        // Values that change depending on content type
        if (result.type === 'podcast') {
            $readTime.parent().remove();
        } else if (result.type === 'session') {
            $readTime.parent().html(' / ' + result.drills + ' Drills');
        } else {
            $readTime.html(result.reading_time);
        }

        // If Flickity Exists
        if ($('.content-filter-results .flickity-slider').length) {
            $carousel.flickity('append', $filteredContent);
            carouselEqualHeightTeasers();
        } else {
            $filterResults.append($filteredContent);
        }
    };


    var lazyLoadFilters = function() {
        $('window').lazyLoad($('.content-filter-options .panel-body'), { absolute: true });
    };


    var hideLazyLoadFilters = function() {
        $('window').hideLazyLoad($('.content-filter-options .panel-body'));
    };


    var hideLoadMore = function() {
        $loadMoreBtn.attr('hidden', true);
    };


    var showLoadMore = function() {
        $('window').hideBtnLoader($loadMoreBtn);
        $loadMoreBtn.attr('hidden', false);
    };


    var loadMore = function() {
        if (morePosts === true) {
            if (apiResult === true) {
                apiResult = false;
                filterContentService(includeLocked, saveParams, ages, contentTypes, cursor, pageSize, loadMoreResponse);
            }
        }
    };


    var changePrefsClick = function() {
        $('#change-filter-preferences').on('click', function(e) {
            e.preventDefault();
            resetResults();
            if ($tgFilter.length) {
                showFilters();
            }
        });
    };


    var checkIfAlreadyFiltered = function() {
        customContentService(savedFeed);
    };


    var showCurrentFilters = function() {
        for (var i = 0; i < ages.length; i++) {
            $filterForm.find('input[value="' + ages[i] + '"]').attr('checked', true);
        }

        for (var i = 0; i < contentTypes.length; i++) {
            $filterForm.find('input[value="' + contentTypes[i] + '"]').attr('checked', true);
        }

        checkIfFilterSelected();
        $filterSubmit.click();
    };


    var savedFeed = function(res) {
        if (res.data) {
            lazyLoadFilters();

            var savedAges = res.data.ages;
            for (var i = 0; i < savedAges.length; i++) {
                ages.push(savedAges[i]);
            }

            var savedContentTypes = res.data.types;
            for (var i = 0; i < savedContentTypes.length; i++) {
                contentTypes.push(savedContentTypes[i]);
            }

            showCurrentFilters();
        }
    };


    var buildCarousel = function() {
        var carouselOptions = {
            percentPosition: false,
            pageDots: false,
            dragThreshold: 20,
            cellAlign: 'center',
        };

        if (window.matchMedia('(min-width: 768px)').matches) {
            carouselOptions.contain = true;
        }

        $carousel.flickity(carouselOptions);
        carouselEqualHeightTeasers();

        var flkty = $carousel.data('flickity');
        var carouselOffset = 1;
        var resultLimit = 60;

        $carousel.on('select.flickity', function() {
            if (flkty.selectedIndex <= resultLimit) {
                if (flkty.selectedIndex === (pageSize * carouselOffset) - 4) {
                    carouselOffset++;
                    loadMore();
                }
            }
        });
    };


    var carouselEqualHeightTeasers = function() {
        var $carouselItem = $carousel.find('.flickity-carousel-item');
        var tallest = 0;

        $carouselItem.each(function() {
            $(this).css('height', 'auto');
            var thisHeight = $(this).height();
            if (thisHeight > tallest) {
                tallest = thisHeight;
            }
        });

        $carouselItem.height(tallest);
    };


    var loadMoreClick = function() {
        $loadMoreBtn.on('click', function(e) {
            e.preventDefault();
            $('window').btnLoader($(this));
            loadMore();
        });
    };


    var init = function() {
        if ($filterForm.length) {
            filterChange();
            filterClick();
            checkIfAlreadyFiltered();
            changePrefsClick();
            loadMoreClick();
        }
    };


    return {
        init: init
    };

})();

contentFilter.init();



// WEBPACK FOOTER //
// ./library/js/modules/content-filter.js